import { Action } from 'redux';

import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { RemoveFromThisCollection } from '../../AppActionTypes';

export interface RemoveFromThisCollectionAction extends Action {
  targetItems: IContentInfo[];
}

export function removeFromThisCollectionAction(targetItems: IContentInfo[]): RemoveFromThisCollectionAction {
  return {
    type: RemoveFromThisCollection,
    targetItems: targetItems,
  };
}
